import { createRoot } from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import { FrontendApp } from './App'
import { installChunkReloadRecovery } from './chunkReloadRecovery'
import { posthogApiKey, posthogOptions } from './services/analytics'
import './progetto-arca-ui.css'
import './styles/global.scss'

installChunkReloadRecovery()

const root = document.getElementById('frontend-root')

if (root) {
  const reactRoot = createRoot(root)
  reactRoot.render(
    posthogApiKey ? (
      <PostHogProvider apiKey={posthogApiKey} options={posthogOptions}>
        <FrontendApp />
      </PostHogProvider>
    ) : (
      <FrontendApp />
    ),
  )
}
